import styled from 'styled-components';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

export const StyledTypography = styled(Typography)`
  text-transform: capitalize;
`;

StyledTypography.displayName = 'StyledTypography';
